<template>
    <div>
        <SrMenu
            transition="slide-y-transition"
            eager
            content-class="color-picker-menu"
            nudge-bottom="8"
            :offset-y="offsetY"
            :offset-x="offsetX"
            :open-on-click="openOnClick"
            :open-on-hover="openOnHover"
            :open-on-focus="openOnFocus"
            :disabled="disabled"
            :close-on-click="closeOnClick"
            :close-on-content-click="closeOnContentClick"
            :z-index="zIndex"
            :min-width="width"
            attach
        >
            <template #activator="{ on }">
                <div :class="classList" v-on.stop="on">
                    <div class="color" :style="{ backgroundColor: value }" />
                    <span class="label">
                        <span class="label-text">{{ label }}</span>
                        <span v-if="required" class="required-indicator"> * </span>

                        <SrInfoBox v-if="hint" class="ml-2">
                            {{ hint }}
                        </SrInfoBox>
                    </span>
                </div>
            </template>
            <VColorPicker
                class="color-picker"
                dot-size="10"
                :mode="mode"
                :width="width"
                :disabled="disabled"
                :value="internalValue"
                v-bind="$attrs"
                @input="onChange"
                v-on="$listeners"
            />
        </SrMenu>
    </div>
</template>

<script>
import { SrInfoBox } from '../SrInfoBox';
import { SrMenu } from '../SrMenu';
import { hasAlpha, isAlphaMode } from './utils';
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'color-input-container';

export default {
    name: 'SrColorInput',
    components: {
        SrInfoBox,
        SrMenu,
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        hint: {
            type: String,
            default: null,
        },
        mode: {
            type: String,
            default: 'hexa',
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        closeOnClick: {
            type: Boolean,
            default: true,
        },
        closeOnContentClick: {
            type: Boolean,
            default: false,
        },
        offsetX: {
            type: Boolean,
            default: false,
        },
        offsetY: {
            type: Boolean,
            default: true,
        },
        openOnClick: {
            type: Boolean,
            default: true,
        },
        openOnHover: {
            type: Boolean,
            default: false,
        },
        openOnFocus: {
            type: Boolean,
            default: false,
        },
        zIndex: {
            type: [Number, String],
            default: undefined,
        },
        value: {
            type: [String, Object],
            required: true,
        },
        width: {
            type: Number,
            default: 200,
        },
        useAlpha: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internalValue: this.value,
        };
    },
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
    watch: {
        value(value) {
            this.processReceivedValue(value);
        },
    },
    created() {
        this.processReceivedValue(this.value);
    },
    methods: {
        onChange(value) {
            this.$emit('input', value);
        },
        processReceivedValue(value) {
            const isAlphaChannelMissing = this.useAlpha && isAlphaMode(this.mode) && !hasAlpha(value);

            if (isAlphaChannelMissing && typeof value === 'string') {
                this.internalValue = `${value}FF`;
            } else if (isAlphaChannelMissing && typeof value === 'object') {
                this.internalValue = { ...value, a: 1 };
            } else {
                this.internalValue = value;
            }
        },
    },
};
</script>
